import { useDispatch } from "react-redux"
import { MyDispatch, MySelector } from "../../redux/store"
import { setShowDownloadModal } from "../../redux/utilSlice"
import {
  Box,
  LinearProgress,
  linearProgressClasses,
  Modal,
  styled,
} from "@mui/material"
import { returnStyle, title } from "../../utils/popupModalStyle"
import folderIcon from "../../assets/download_folder.svg"

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: "#26272C",
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: "#FBCA7F",
  },
}))

const DownloadModal = () => {
  const dispatch = useDispatch<MyDispatch>()

  const {
    downloadData: { showModal, currentPart, progress, totalParts },
  } = MySelector((state) => state.util)
  const { theme } = MySelector((state) => state.theme)

  return (
    <Modal
      open={showModal}
      onClose={() => {
        dispatch(setShowDownloadModal(false))
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={returnStyle(theme)}>
        <div className="p-5 md:px-[26.11px] md:py-[33.25px]">
          <p className={title}>Downloading your files...</p>
          <div className="flex items-center justify-between my-4 md:mt-7 md:mb-6">
            <div className="flex items-center gap-2.5">
              <img
                src={folderIcon}
                alt=""
                className="h-9 w-9 md:h-12 md:w-12"
              />
              <div>
                <p className="text-newOffBlack dark:text-white">Zip folder {currentPart + 1}</p>
                <p className="text-offGrey text-sm md:text-base mt-1">
                  {progress}%
                </p>
              </div>
            </div>
            <p className="text-white">{progress}%</p>
          </div>

          <BorderLinearProgress variant="determinate" value={progress} />
        </div>
      </Box>
    </Modal>
  )
}

export default DownloadModal
